export const messagesApiQueryKeys = {
  all: () => ['messages'] as const,
  byId: (id: string) => ['messages', id] as const,
  byTour: (tourId: string) => ['tours', tourId, 'messages'] as const,
  byBooking: (bookingId: string) =>
    ['bookings', bookingId, 'messages'] as const,
};

const SCOPED_MESSAGE_ROOTS = ['tours', 'bookings'];

/**
 * Listy wiadomości zawężone rekordem. Akcja wiersza może paść na każdej z nich, a żadna nie siedzi
 * pod `['messages']`, więc po anulowaniu, ponowieniu i archiwizacji trzeba unieważnić je wszystkie.
 *
 * To prefiks, nie cały klucz: tabela dokleja do niego stan (strona, filtry, fraza), a lista mobilna
 * jeszcze `'infinite'` — porównanie z kluczem długości 3 nie trafiało w nic. Definicja kolumn wisi
 * pod tym samym prefiksem i akcja wiersza jej nie zmienia, więc zostaje poza unieważnieniem.
 */
export const isScopedMessagesQueryKey = (key: readonly unknown[]): boolean =>
  key.length >= 3 &&
  typeof key[0] === 'string' &&
  SCOPED_MESSAGE_ROOTS.includes(key[0]) &&
  key[2] === 'messages' &&
  key[3] !== 'table-definition';
